var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[(_vm.loading)?_c('DefaultLoading',{attrs:{"loading":_vm.loading}}):_vm._e(),(!_vm.loading && !_vm.error && _vm.pdfContent)?_c('div',{staticClass:"pdf-wrapper"},[_c('vue-pdf-app',{directives:[{name:"pdf-app-load",rawName:"v-pdf-app-load"}],attrs:{"pdf":_vm.pdfContent,"file-name":_vm.fileName,"page-scale":"page-width"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }